const CookieAnn = (props) => {
  return (
    <section className="w-full flex items-center fixed bottom-0 left-0 bg-[#2a2525] text-white p-2 z-50">
      <div className="flex flex-row justify-between w-full px-3">
        {props.currentLang === "eng" ? (
          <p>
            We use cookies in line with our privacy policy to provide you with a
            better service.{" "}
            <a
              className="underline"
              href="https://www.unilevernotices.com/cookie-notices/global-en_gb.html"
            >
              Click for more information about cookies
            </a>
            .
          </p>
        ) : (
          <p>
            Size daha iyi bir hizmet sunabilmek için gizlilik politikamız
            doğrultusunda çerezler kullanıyoruz.
            <a
              className="underline"
              href="https://www.unilevernotices.com/cookie-notices/turkey-turkish.html"
            >
              Çerezler hakkında daha fazla bilgi için tıklayın
            </a>
            .
          </p>
        )}
        <button
          onClick={() => props.setCookie(false)}
          className="bg-yellow-500 px-2 py-1 text-black text-base"
        >
          {props.currentLang === "eng" ? "ACCEPT" : "ANLADIM"}
        </button>
      </div>
    </section>
  );
};

export default CookieAnn;
